import {gql} from "apollo-angular";

export const CITIZEN_GET_EXCHANGE_CURRENCY_COST = gql`
    query CitizenGetExchangedCurrencyCost($exchange: ExchangeInputObject) {
        citizenGetExchangedCurrencyCost(exchange: $exchange) {
            response {
                id
                status
                code
                message
            }
            data {
                currentCurrency
                amountFromChange
                transactionDate
            }
        }
    }
`;

export interface CurrencyCost {
    currentCurrency?: string;
    amountFromChange?: number;
    transactionDate?: Date;
}
